import http from '../../axios-config/g-http-metodos';
function getPotencial () {
  const { res, erro, requisicao } = http.get(`ClienteDesenvolvimento/Potencial/Get`)
  return { PotencialArray: res , erro, requisicao }
}

function getPerfilMateriais(){
    const { res, erro, requisicao } = http.get(`ClienteDesenvolvimento/PerfilMaterial/Get`)
    return { PerfilMateriais: res, erro, requisicao}
}

function getSegmento () {
  const { res, erro, requisicao } = http.get(`ClienteDesenvolvimento/Segmento/Get`)
  return { Segmentos: res, erro, requisicao}
}

function getSituacao () {
    const { res, erro, requisicao } = http.get(`ClienteDesenvolvimento/Situacao/Get`)
    return { Situacao: res, erro, requisicao}
}

function SalvarClienteEmDesenvolvimento (parametro) {
  const { res, erro, requisicao } = http.post(`ClienteDesenvolvimento/SalvarClienteEmDesenvolvimento`, parametro)
  return { Cliente: res, erro, requisicao}
}



const ClienteDesenvolvimentoController = {
  getPerfilMateriais,
  getPotencial,
  getSegmento,
  getSituacao,
  SalvarClienteEmDesenvolvimento
}

export default ClienteDesenvolvimentoController;
